module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-default margin-bottom-0px"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Keywords List")]), _vm._v(" "), _c('div', {
    staticClass: "action-button pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "NewKeywordsDetails"
    }
  }, [_vm._v("Add Keyword")])], 1)]), _vm._v(" "), (_vm.actionInProgress) ? _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/loader/nivi-loader.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-footer no-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-good-table', {
    attrs: {
      "mode": "remote",
      "styleClass": "vgt-table good-table condensed striped",
      "columns": _vm.columns,
      "rows": _vm.keywordData,
      "totalRows": _vm.keywordCount,
      "pagination-options": {
        enabled: true,
        perPage: 20
      }
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_vm._t("default", null, {
          "props": props
        }), _vm._v(" "), (props.column.field == 'createdAt') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')) + "\n                      ")]) : (props.column.field == 'copy') ? _c('span', [_c('router-link', {
          attrs: {
            "to": ("NewKeywordsDetails?keywordId=" + (props.row.id) + "&action=copyKeyword")
          }
        }, [_c('i', {
          staticClass: "fa fa-copy",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1) : (props.column.field == 'edit') ? _c('span', [_c('router-link', {
          attrs: {
            "to": ("NewKeywordsDetails?keywordId=" + (props.row.id))
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1) : (props.column.field == 'delete') ? _c('span', [_c('i', {
          staticClass: "fa fa-times-circle",
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.showDeleteConfirmationPopup(props.row, props.index)
            }
          }
        })]) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, true)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-keyboard-o",
      "title": "No keywords found",
      "hint": "Try changing the filters, or create a new keyword.",
      "action-label": "Create keyword",
      "action-to": "/NewKeywordsDetails"
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "loadingContent"
  })], 2)], 1)])])])])])]), _vm._v(" "), (_vm.isDeleteConfirmationVisible) ? _c('deleteConfirmationModal', {
    attrs: {
      "isDeleteConfirmationVisible": _vm.isDeleteConfirmationVisible,
      "confirmationMessage": _vm.confirmationMessage,
      "actionToBePerformed": _vm.actionToBePerformed
    },
    on: {
      "close": _vm.closeConfirmationModal,
      "deleteKeyword": _vm.deleteKeyword
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Keywords Management\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("Keywords")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Keywords List")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-521e6f08","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/keyword-management/keywordsList.vue
// module id = E1dl
// module chunks = 1